import React, { useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { approvedFund, rejectFund } from "../service/service";
import { Loader } from "./Loader";
import Pagination from "./Pagination";
const Table = ({AddFund, list: initialList, head,getInformation,handleGetUserDetails }) => {
  const navigate = useNavigate()
  const[loader,setLoader]=useState(false)
  const [list, setList] = useState((initialList || []).slice().reverse())
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1)
  const PAGE_SIZE = 10

  React.useEffect(() => {
    setList((initialList || []).slice().reverse())
  }, [initialList])

  const filteredList = list?.filter(item =>
    (item?.user_id__first_name?.toLowerCase() || '').includes(search.toLowerCase()) ||
    (item?.user_id__phone_number?.toString() || '').includes(search)
  )
  const totalPages = Math.ceil((filteredList?.length || 0) / PAGE_SIZE)
  const pagedList = filteredList?.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE)

  const totalAmount = list?.reduce((sum, item) => sum + (parseFloat(item?.amount) || 0), 0)

  const updateItemStatus = (withdrawl_id, status) => {
    setList(prev => prev.map(item => item.id === withdrawl_id ? { ...item, is_rejected: status } : item))
  }

  const handleApporvedWithdraw =(data)=>{
    setLoader(true)
    approvedFund(data).then((res)=>{
      updateItemStatus(data.withdrawl_id, 'APPROVE')
      if(handleGetUserDetails){
        handleGetUserDetails()
      }
      setLoader(false)
    }).catch((err)=>{
      alert(err?.response?.data?.message||"something went wrong ")
      setLoader(false)
    })
  }
  const handleRejectWithdraw =(data)=>{
    setLoader(true)
    rejectFund(data).then((res)=>{
      updateItemStatus(data.withdrawl_id, 'REJECT')
      setLoader(false)
    }).catch((err)=>{
      alert(err?.response?.data?.message||"something went wrong ")
      setLoader(false)
    })
  }


  return (
    <>
    {loader?<Loader/>:null}
      <div className="card mb-3">
        <div className="card-header d-flex justify-content-between align-items-center">
          <span><i className="fa fa-table"></i> <b>{head}{!AddFund && list?.length > 0 ? ` (Total: ₹${totalAmount})` : ''}</b></span>
          {!AddFund && <input type="text" placeholder="Search by name or mobile..." value={search} onChange={e => { setSearch(e.target.value); setPage(1) }} style={{width:'220px', padding:'3px 8px', borderRadius:'4px', border:'1px solid #ccc', fontSize:'16px'}} />}
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table
              className="table table-bordered"
              id="dataTable"
              width="100%"
              cellspacing="0"
              cellpadding="0"
            >
              <thead>
                <tr>

                  <th>User Name</th>
                  {!AddFund ? <th>Mobile</th>:null}
                  <th>Amount</th>
                  {!AddFund ? <th>Request ID</th>:null}
              
                  <th>Date</th>
             
                  {!AddFund ? <th>Status</th>:null}

                  {!AddFund ? <th>Action</th>:null}
                </tr>
              </thead>
              <tbody>
                {
                  pagedList?.map((item, index) => {
                    return (
                      <tr key={index}>

                        <td>
                          <span className="link" style={{color:'#0d6efd',cursor:'pointer',textDecoration:'underline'}} onClick={() => navigate('/user-details', { state: { id: item?.user_id } })}>{item?.user_id__first_name}</span>
                          {!AddFund && item?.user_id__phone_number && <a href={`https://wa.me/91${item?.user_id__phone_number}`} target="_blank" rel="noreferrer" style={{marginLeft:'6px',color:'#25D366'}}><i className="fa fa-whatsapp" style={{fontSize:'16px'}}></i></a>}
                        </td>
                        {!AddFund ?  <td>{item?.user_id__phone_number}</td>:null}
                        <td>{item?.amount}</td>
                        {!AddFund ?   <td>{item?.id}</td>:null}

                        <td>{moment(item?.created_at).format("DD-MM-YYYY , h:mm:ss a")}</td>
                       {!AddFund ? <td><span className={item?.is_rejected ==="PENDING" ? "btnspan pending" :  item?.is_rejected==="APPROVE"?"btnspan success":"btnspan danger"}>
                          {item?.is_rejected }
                        </span></td>:null}


                       {!AddFund ?<td> <Button variant="primary" className="m-1" onClick={()=>{
                          handleApporvedWithdraw({withdrawl_id:item?.id})
                        }} disabled={item?.is_rejected !=="PENDING"} >
                           Approve
                        </Button>
                          <Button variant="danger" className="m-1" onClick={()=>{
                            handleRejectWithdraw({withdrawl_id:item?.id})
                          }}
                          disabled={item?.is_rejected !=="PENDING"}
                          >
                            Reject
                          </Button>
                        </td>:null}

                      </tr>
                    )
                  })
                }


              </tbody>
            </table>
          </div>
        </div>
        <div className="card-footer">
          <div className="small text-muted mb-1">Showing {filteredList?.length === 0 ? 0 : (page-1)*PAGE_SIZE+1}–{Math.min(page*PAGE_SIZE, filteredList?.length || 0)} of {filteredList?.length || 0} entries</div>
          <Pagination page={page} totalPages={totalPages} onPageChange={setPage} />
        </div>
      </div>
    </>
  );
};

export default Table;
